// TODO: use <SiderMenuItemWithAction /> for all the menu items
/* eslint-disable */
import {
  UserOutlined,
  LoginOutlined,
  RightOutlined,
  LeftOutlined,
  DatabaseOutlined,
  UsergroupAddOutlined,
  FileSyncOutlined,
  SecurityScanOutlined
} from '@ant-design/icons';

import { useEffect, useState } from 'react';

// import { useOktaAuth } from '@okta/okta-react';
import { Layout, Menu, Dropdown, Button } from 'antd';
import { Link, NavLink } from 'react-router-dom';

import VendorAgreementModal from './VendorAgreementModal';
import { InventoryIcon, MensaLogo, PurchasesIcon, SalesIcon } from '../../Assets/index';
import { LINKS, localStorageUtility } from '../../clientUtils';
import { UAR_ALLOWED_GROUPS, USER_MANAGEMENT_PERMISSION_GROUP, USER_ROLE_KEY } from '../../constants';
import { USER_ACCESS_MODES, createUserAccessProfile } from '../../Utils/userAccessPolicy';
import SiderMenuItemWithAction from './SiderMenuItemWithAction';
import { useAuth0 } from '@auth0/auth0-react';

const { Content, Sider } = Layout;

function getItem(label, key, icon, children) {
  return {
    key,
    icon,
    children,
    label
  };
}

const AppLayout = ({ children, className, selected, overrideContent, openGroup }) => {
  // const { oktaAuth } = useOktaAuth();
  // const navigate = useNavigate();
  const { user, isAuthenticated, isLoading, loginWithRedirect, logout } = useAuth0();

  const [collapsed, setCollapsed] = useState(false);
  // const [user, setUser] = useState();

  // useEffect(() => {
  //   // const getUser = async () => {
  //   //   const res = await oktaAuth.getUser();
  //   //   setUser(res);
  //   // };
  //   // const u = oktaAuth.storageManager.getTokenStorage().getStorage()?.idToken?.claims;
  //   setUser(us);
  //   // if (!us) getUser();
  // }, [us, isLoading, isAuthenticated]);

  useEffect(() => {
    if (!localStorageUtility.getItem('showAgreement')) localStorageUtility.setItem('showAgreement', 'yes');
  }, []);

  const handleCollapse = () => {
    setCollapsed((prevState) => !prevState);
  };

  const navMap = {
    purchaseOrder: '/purchases/purchase-order',
    purchaseRequest: '/purchases/purchase-request',
    asn: '/purchases/asn',
    'po-grn': '/purchases/grn',
    customerPO: '/sales/customer-po',
    documentParser: '/document-parser',
    domesticSalesOrder: '/sales/domestic-sales-order',
    customerBills: '/sales/customer-bills',
    internationalSalesOrder: '/sales/international-sales-order',
    'so-dgrn': '/sales/domestic-grn',
    'so-igrn': '/sales/international-grn',
    ro: '/sales/ro',
    poReturnOrder: '/purchases/return-order',
    vendorBills: '/purchases/vendor-bills',
    debitNotes: '/purchases/debit-notes'
  };

  const purchaseRequestMenuItems = [
    {
      key: 'domestic',
      label: <Link to="/purchases/purchase-request/domestic/create"> FG Domestic</Link>
    },
    {
      key: 'international',
      label: <Link to="/purchases/purchase-request/international/create">FG International</Link>
    }
  ];

  const customerPOMenuItems = [
    {
      key: 'sales_dom_online',
      label: <Link to="/sales/customer-po/online/create">Domestic Online</Link>
    },
    {
      key: 'sales_dom_online-excess',
      label: <Link to="/sales/customer-po/online-excess/create">Domestic Online Excess</Link>
    }
  ];

  const documentParserMenuItems = [
    {
      key: 'parser-purchase-order',
      label: <Link to="/document-parser/purchase-order">Purchase Order</Link>
    },
    {
      key: 'parser-invoice',
      label: <Link to="/document-parser/invoice">Invoice</Link>
    },
    {
      key: 'parser-awb',
      label: <Link to="/document-parser/awb">AWB</Link>
    }
  ];

  const purchaseRequest = (
    <Link className="item-with-action" to="/purchases/purchase-request">
      <span>Purchase Request</span>
      <Dropdown menu={{ items: purchaseRequestMenuItems }}>
        <span className="circle plus" />
      </Dropdown>
    </Link>
  );

  const customerPO = (
    <Link className="item-with-action" to={navMap.customerPO}>
      <span>Customer PO</span>
      <Dropdown menu={{ items: customerPOMenuItems }}>
        <span className="circle plus" />
      </Dropdown>
    </Link>
  );

  const documentParser = (
    <Link className="item-with-action" to={navMap.documentParser}>
      <span>Document Parser</span>
      <Dropdown menu={{ items: documentParserMenuItems }}>
        <span className="circle plus" />
      </Dropdown>
    </Link>
  );

  const grnMenuItems = [
    {
      key: 'gf-international-grn',
      label: <Link to="/purchases/grn/international/create">FG International</Link>,
      disabled: true
    }
  ];

  const poReturnOrderMenuItems = [
    {
      key: 'po-domestic-return-order',
      label: <Link to="/purchases/return-order/domestic">FG Domestic</Link>
    }
  ];

  const purchaseGRN = (
    <Link className="item-with-action" to="/purchases/grn">
      <span>GRN</span>
      <Dropdown menu={{ items: grnMenuItems }}>
        <span className="circle plus" />
      </Dropdown>
    </Link>
  );

  const poReturnOrder = (
    <Link className="item-with-action" to={navMap.poReturnOrder}>
      <span>Return Order</span>
      {(user?.[USER_ROLE_KEY]?.includes('SUPER_ADMIN') ||
        user?.[USER_ROLE_KEY]?.includes('RTV_DOMESTIC_BULK_CREATION')) && (
        <Dropdown menu={{ items: poReturnOrderMenuItems }}>
          <span className="circle plus" />
        </Dropdown>
      )}
    </Link>
  );

  const purchaseOrder = (
    <Link className="item-with-action" to="/purchases/purchase-order">
      <span>Purchase Order</span>
    </Link>
  );

  const vendorBills = (
    <Link className="item-with-action" to={navMap.vendorBills}>
      <span>Vendor Bills</span>
    </Link>
  );

  const debitNotes = (
    <Link className="item-with-action" to={navMap.debitNotes}>
      <span>Debit Notes</span>
    </Link>
  );


  const asnMenu = [
    {
      key: 'asn',
      label: <Link to="/purchases/asn/domestic/create">FG Domestic</Link>
    },
    {
      key: 'asn-international',
      label: <Link to="/purchases/asn/international/create">FG International</Link>
    }
  ];

  const asn = (
    <Link className="item-with-action" to="/purchases/asn">
      <Link to="/purchases/asn">ASN</Link>
      <Dropdown menu={{ items: asnMenu }}>
        <span className="circle plus" />
      </Dropdown>
    </Link>
  );

  const internationalSoMenu = [
    {
      key: 'export-online',
      label: <Link to="/sales/international-sales-order/export-online/create">Export Online</Link>
    },
    {
      key: 'international-stock-transfer',
      label: (
        <Link to="/sales/international-sales-order/international-stock-transfer/create">
          International Stock Transfer
        </Link>
      )
    },
    {
      key: 'warehouse-shipping',
      label: (
        <Link to="/sales/international-sales-order/warehouse-shipping/create">Export Online Warehouse Shipping</Link>
      )
    }
  ];

  const soDomesticGRNMenu = [
    {
      key: 'domestic',
      label: <Link to="/sales/domestic-grn/domestic-online/create">Domestic Online</Link>
    },
    {
      key: 'domestic-excess',
      label: <Link to="/sales/domestic-grn/domestic-online-excess/create">Domestic Online Excess</Link>
    },
    {
      key: 'internal-stock-transfer',
      label: <Link to="/sales/domestic-grn/internal-stock-transfer/create">Internal Stock Transfer</Link>
    },
    {
      key: 'so-grn-refurbish-internal',
      label: <Link to="/sales/domestic-grn/refurbish-internal/create">Refurbish Internal</Link>
    },
    {
      key: 'so-grn-refurbish-external',
      label: <Link to="/sales/domestic-grn/refurbish-external/create">Refurbish External</Link>
    }
  ];

  const soInternationalGRNMenu = [
    {
      key: 'export-online',
      label: <Link to="/sales/international-grn/export-online/create">Export Online</Link>
    },
    {
      key: 'international-stock-transfer',
      label: <Link to="/sales/international-grn/international-stock-transfer/create">International Stock Transfer</Link>
    },
    {
      key: 'export-online-wh-shipping',
      label: <Link to="/sales/international-grn/warehouse-shipping/create">Export Online Warehouse Shipping</Link>
    }
  ];

  // const domesticSalesOrder = (
  //   <Link className="item-with-action" to={navMap.domesticSalesOrder}>
  //     <span>Sales Order</span>
  //     <Dropdown menu={{ items: domesticSoMenu }}>
  //       <span className="circle plus" />
  //     </Dropdown>
  //   </Link>
  // );
  const domesticSalesOrder = (
    <SiderMenuItemWithAction
      title="Sales Order"
      to={navMap.domesticSalesOrder}
      menu={[
        {
          key: 'domestic-online',
          label: <Link to="/sales/domestic-sales-order/domestic-online/create">Domestic Online</Link>
        },
        {
          key: 'domestic-offline',
          label: <Link to="/sales/domestic-sales-order/domestic-offline/create">Domestic Offline</Link>
        },
        {
          key: 'internal-stock-transfer',
          label: <Link to="/sales/domestic-sales-order/internal-stock-transfer/create">Internal Stock Transfer</Link>
        },
        {
          key: 'liquidation',
          label: <Link to="/sales/domestic-sales-order/liquidation/create">Liquidation</Link>
        },
        {
          key: 'refurbish-so-internal',
          label: <Link to="/sales/domestic-sales-order/refurbish-internal/create">Refurbish Internal</Link>
        },
        {
          key: 'refurbish-so-external',
          label: <Link to="/sales/domestic-sales-order/refurbish-external/create">Refurbish External</Link>
        }
      ]}
    />
  );

  const internationalSalesOrder = (
    <Link className="item-with-action" to={navMap.internationalSalesOrder}>
      <span>Sales Order</span>
      <Dropdown menu={{ items: internationalSoMenu }}>
        <span className="circle plus" />
      </Dropdown>
    </Link>
  );

  // const soDomesticGRN = (
  //   <Link className="item-with-action" to={navMap['so-dgrn']}>
  //     <span>GRN</span>
  //     <Dropdown menu={{ items: soDomesticGRNMenu }}>
  //       <span className="circle plus" />
  //     </Dropdown>
  //   </Link>
  // );

  const soInternationalGRN = (
    <Link className="item-with-action" to={navMap['so-igrn']}>
      <span>GRN</span>
      <Dropdown menu={{ items: soInternationalGRNMenu }}>
        <span className="circle plus" />
      </Dropdown>
    </Link>
  );

  const roMenu = [
    {
      key: 'domestic',
      label: <Link to="/sales/ro/create/DOMESTIC_ONLINE">Domestic Online</Link>
    },
    {
      key: 'domesticOffline',
      label: <Link to="/sales/ro/create/DOMESTIC_OFFLINE">Domestic Offline</Link>
    }
  ];

  // const handleLogout = () => {
  //   const logout = async () => {
  //     localStorageUtility.removeItem('showAgreement');
  //     // await oktaAuth.signOut();
  //   };
  //   logout();
  // };

  const logoutWithRedirect = () => {
    localStorageUtility.onLogout();
    logout({
      logoutParams: {
        returnTo: window.location.origin
      }
    });
  };

  const logoutt = (
    <Button icon={<LoginOutlined />} onClick={logoutWithRedirect} type="link">
      Logout
    </Button>
  );

  const returnOrder = (
    <Link className="item-with-action" to={navMap.ro}>
      <span>Return Order</span>
      <Dropdown menu={{ items: roMenu }}>
        <span className="circle plus" />
      </Dropdown>
    </Link>
  );

  const getLinkMenuItem = (key, label, link) => ({ key, label: <Link to={link}>{label}</Link> });

  const bulkMenu = {
    BULK_UPLOAD_TB: {
      value: 'TB PO Creation',
      key: 'trustbasket',
      path: '/bulkuploader/trustbasket'
    },
    BULK_UPLOAD_PO: {
      value: 'PO Creation',
      key: 'po-bulk',
      path: '/bulkuploader/po'
    },
    BULK_UPLOAD_PO_ALLOCATION: {
      value: 'PO Allocation',
      key: 'po-allocation-bulk',
      path: '/bulkuploader/po-allocation'
    },
    BULK_UPLOAD_SO_APPOINTMENT: {
      value: 'SO Appointment',
      key: 'so-appointment-bulk',
      path: '/bulkuploader/so-appointment'
    },
    BULK_UPLOAD_SO_DISPATCH: {
      value: 'SO Dispatch',
      key: 'so-dispatch-bulk',
      path: '/bulkuploader/so/dispatch'
    },
    BULK_UPLOAD_SO_DELIVER: {
      value: 'SO Deliver',
      key: 'so-deliver-bulk',
      path: '/bulkuploader/so/deliver'
    },
    INTERNATIONAL_SO: {
      key: 'international_so',
      value: 'International SO',
      children: [
        getLinkMenuItem('eo-dispatch-bulk', 'Mark Dispatch', '/bulkuploader/eo-dispatch'),
        getLinkMenuItem('eo-deliver-bulk', 'Mark Deliver', '/bulkuploader/eo-deliver')
      ]
    },
    RETURN_ORDER: {
      key: 'return_order',
      value: 'Return Order',
      children: [
        getItem(
          <SiderMenuItemWithAction
            to={LINKS.returnOrder.bulkUploader.domesticOnline}
            title="Create"
            menu={[
              {
                key: 'roc_dom_online',
                label: <Link to={LINKS.returnOrder.bulkUploader.domesticOnline}>Domestic Online</Link>
              },
              {
                key: 'roc_dom_offline',
                label: <Link to={LINKS.returnOrder.bulkUploader.domesticOffline}>Domestic Offline</Link>
              },
              {
                key: 'roc_refurbish_internal',
                label: <Link to={LINKS.returnOrder.bulkUploader.refurbishInternal}>Refurbish Internal</Link>
              },
              {
                key: 'roc_refurbish_external',
                label: <Link to={LINKS.returnOrder.bulkUploader.refurbishExternal}>Refurbish External</Link>
              }
            ]}
          />,
          'RO_create'
        ),
        ...[
          // getLinkMenuItem(
          //   'bu_ro_send_for_approval',
          //   'Send for Approval',
          //   LINKS.returnOrder.bulkUploader.sendForApproval
          // ),
          getLinkMenuItem('bu_ro_approve', 'Approval', LINKS.returnOrder.bulkUploader.approve),
          getLinkMenuItem('bu_ro_mark_as_open', 'Mark As Open', LINKS.returnOrder.bulkUploader.markAsOpen),
          getLinkMenuItem('bu_ro_dispatch', 'Dispatch', LINKS.returnOrder.bulkUploader.dispatch),
          getLinkMenuItem('bu_ro_deliver', 'Deliver', LINKS.returnOrder.bulkUploader.deliver),
          getItem(
            <SiderMenuItemWithAction
              title="Inward Order"
              menu={[
                {
                  key: 'bu_ro_inward_order_single',
                  label: <Link to={LINKS.returnOrder.bulkUploader.inwardOrderSingle}>Single</Link>
                },
                {
                  key: 'bu_ro_inward_order_group',
                  label: <Link to={LINKS.returnOrder.bulkUploader.inwardOrderGroup}>Group</Link>
                }
              ]}
            />,
            'bu_ro_inward_order'
          )
        ]
      ]
    }
  };

  const getBulkUploaderOptions = (groups) => {
    let menuArray = [];
    groups?.map((grp) => bulkMenu[grp] && menuArray.push(bulkMenu[grp]));
    menuArray.push(bulkMenu.RETURN_ORDER);
    // Add International SO menu with role-based access
    const hasFullAccess = groups?.includes('SUPER_ADMIN') || groups?.includes('SUPER_TECH_ADMIN');
    const hasDispatchAccess = hasFullAccess || groups?.includes('INT_BULK_DISPATCH');
    const hasDeliverAccess = hasFullAccess || groups?.includes('INT_BULK_DELIVER');

    if ((hasDispatchAccess || hasDeliverAccess) && !menuArray.some((item) => item.key === 'international_so')) {
      const internationalSOChildren = [];
      if (hasDispatchAccess) {
        internationalSOChildren.push(getLinkMenuItem('eo-dispatch-bulk', 'Mark Dispatch', '/bulkuploader/eo-dispatch'));
      }
      if (hasDeliverAccess) {
        internationalSOChildren.push(getLinkMenuItem('eo-deliver-bulk', 'Mark Deliver', '/bulkuploader/eo-deliver'));
      }
      if (internationalSOChildren.length > 0) {
        menuArray.push({
          key: 'international_so',
          value: 'International SO',
          children: internationalSOChildren
        });
      }
    }
    if (menuArray.length > 0) {
      return getItem(
        'Bulk Uploaders',
        'bulkUploaders',
        <InventoryIcon />,
        menuArray.map((item) =>
          getItem(
            item?.path ? <Link to={item.path}>{item.value}</Link> : item.value,
            item.key,
            item?.icon,
            item?.children
          )
        )
      );
    }
    return null;
  };

  const getUserManagementOptions = (groups) => {
    let menuArray = [
      {
        value: 'User Management',
        key: 'usersList',
        path: '/users/list'
      }
    ];

    if (groups?.includes(USER_MANAGEMENT_PERMISSION_GROUP)) {
      return getItem(
        'User Management',
        'users',
        <UsergroupAddOutlined />,
        menuArray.map((item) => getItem(<Link to={item.path}>{item.value}</Link>, item.key))
      );
    }
    return null;
  };

  const groups = user?.[USER_ROLE_KEY];
  const accessProfile = createUserAccessProfile(groups);
  const normalizedGroups = Array.isArray(groups) ? groups : [];

  const profileMenuItem = getItem(
    user?.name,
    'profile',
    <UserOutlined
      style={{
        color: '#fff'
      }}
    />,
    [getItem(logoutt, 'logout')]
  );

  const getAccessControlOptions = (groups) => {
    let menuArray = [
      {
        value: 'User Access Reviews',
        key: 'uarList',
        path: '/access-control/user-access-reviews'
      },
      {
        value: 'Create Review',
        key: 'uarCreate',
        path: '/access-control/user-access-reviews/create'
      }
    ];

    if (groups?.some((group) => UAR_ALLOWED_GROUPS.includes(group))) {
      return getItem(
        'Access Control',
        'accessControl',
        <SecurityScanOutlined />,
        menuArray.map((item) => getItem(<Link to={item.path}>{item.value}</Link>, item.key))
      );
    }
    return null;
  };

  const menuItems = [
    getItem('Purchases', 'purchases', <PurchasesIcon />, [
      getItem(purchaseRequest, 'purchaseRequest'),
      getItem(purchaseOrder, 'purchaseOrder'),
      getItem(asn, 'asn'),
      getItem(purchaseGRN, 'po-grn'),
      getItem(poReturnOrder, 'poReturnOrder'),
      getItem(vendorBills, 'vendorBills'),
      getItem(debitNotes, 'debitNotes')
    ]),
    getItem('Sales', 'sales', <SalesIcon />, [
      getItem('Domestic', 'sales-domestic', undefined, [
        getItem(customerPO, 'customerPO'),
        getItem(domesticSalesOrder, 'domesticSalesOrder'),
        getItem(returnOrder, 'returnOrder'),
        getItem(<SiderMenuItemWithAction menu={soDomesticGRNMenu} title="GRN" to={navMap['so-dgrn']} />, 'so-dgrn'),
        getItem(<Link to={navMap.customerBills}>Customer Bills</Link>, 'customerBills')
      ]),
      getItem('International', 'sales-international', undefined, [
        getItem(internationalSalesOrder, 'internationalSalesOrder'),
        getItem(soInternationalGRN, 'so-igrn')
      ]),
      ...[
        getItem('Bulk actions', 'bulk_actions', undefined, [
          getLinkMenuItem(
            'return_order_bulk_upload',
            'Domestic Online Return Order',
            '/sales/bulk-actions/return-order-create'
          ),
          getLinkMenuItem(
            'bulk_epod_manual_upload',
            'Bulk EPOD Upload',
            '/sales/bulk-actions/epod-manual-upload'
          ),
          getLinkMenuItem(
            'bulk_appointment_download',
            'Bulk Appointment Download',
            '/sales/bulk-actions/appointment-files-download'
          )
        ])
      ],
      ...(accessProfile.canAccessPrintTag
        ? [getItem(<Link to="/sales/print-tag">Print Tag</Link>, 'print-tag')]
        : [])
      // getItem("Return Order", "s-returnOrder"),
      // getItem("Payments", "s-payments"),
    ]),
    getItem(
      <NavLink to="https://masters.mensa.one" style={{ color: 'white' }}>
        Masters
      </NavLink>,
      'masters',
      <DatabaseOutlined style={{ scale: '1.5', padding: '4px' }} width="2em" />,
      [
        getItem(
          <SiderMenuItemWithAction
            title="Transfer Pricing"
            to="/masters/transfer_pricing"
            menu={[
              {
                key: 'upload_transfer_pricing',
                label: <Link to="/masters/transfer-pricing/bulk/upload">Bulk Upload</Link>
              },
              {
                key: 'update_transfer_pricing',
                label: <Link to="/masters/transfer-pricing/bulk/update">Bulk Update</Link>
              }
            ]}
          />,
          'transfer_pricing'
        ),
        getItem(
          <SiderMenuItemWithAction
            title="COGS"
            to="/masters/cogs"
            menu={[{ key: 'upload_cogs', label: <Link to="/masters/cogs/bulk/upload">Bulk Upload</Link> }]}
          />,
          'cogs'
        )
      ]
    ),
    getItem(documentParser, 'document-parser', <FileSyncOutlined />),
    getBulkUploaderOptions(normalizedGroups),
    getUserManagementOptions(normalizedGroups),
    getAccessControlOptions(normalizedGroups),
    profileMenuItem
  ];

  const printOnlyMenu = [getItem(<Link to="/sales/print-tag">Print Tag</Link>, 'print-tag'), profileMenuItem];

  const vendorMenu = [
    getItem('Purchases', 'purchases', <PurchasesIcon />, [getItem(asn, 'asn'), profileMenuItem])
  ];

  const menuMapper = () => {
    if (!user) return [];
    if (accessProfile.mode === USER_ACCESS_MODES.NONE) return [];
    if (accessProfile.mode === USER_ACCESS_MODES.PRINT_ONLY) return printOnlyMenu;
    if (accessProfile.mode === USER_ACCESS_MODES.VENDOR) return vendorMenu;
    return menuItems;
  };

  // Add this loading guard
  if (isLoading) {
    return <div>Loading...</div>; // Or your Loading component
  }

  // Add null check with fallback
  if (!user) {
    return <div>Authentication required</div>;
  }

  return (
    <Layout className="sidebar" style={{ minHeight: '100vh' }}>
      <VendorAgreementModal />
      <Sider
        collapsed={collapsed}
        collapsible
        onCollapse={(value) => setCollapsed(value)}
        style={{
          overflow: 'auto',
          height: '100vh',
          position: 'fixed',
          left: 0,
          top: 0,
          bottom: 0
        }}
        theme="light"
        width="280">
        <div className={collapsed ? 'logo collapsed' : 'logo'}>
          <MensaLogo />
          {!collapsed ? <span>Lumos (POSI) </span> : null}
        </div>
        <Menu
          defaultOpenKeys={openGroup ? openGroup : ['purchases', 'sales', 'sales-domestic', 'sales-international']}
          mode="inline"
          items={menuMapper()}
          selectedKeys={[selected]}
          theme="light"
        />
        <div
          className="collapse-trigger"
          onClick={handleCollapse}
          onKeyDown={handleCollapse}
          role="button"
          tabIndex={0}>
          {collapsed ? <RightOutlined /> : null}
          {!collapsed && <LeftOutlined />}
        </div>
      </Sider>
      <Layout
        className={overrideContent || 'content'}
        style={{
          marginLeft: collapsed ? 80 : 280
        }}>
        <Content className={className}>{children}</Content>
      </Layout>
    </Layout>
  );
};

export default AppLayout;
